import React from 'react';

import 'lazysizes';


import 'prismjs/themes/prism-tomorrow.css';

import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;

export const onRouteUpdate = () => {

  main.scrollTo(0, 0);
  
};